import type { SelectOption } from '../../../components/SelectCustom'
import type { ShopLanguage } from '../../../i18n'
import { PAGE_SIZE_OPTIONS } from './types'

export const PAGE_SIZE_SELECT_OPTIONS: SelectOption[] = PAGE_SIZE_OPTIONS.map((size) => ({
  value: String(size),
  label: String(size),
}))

export const getSortSelectOptions = (language: ShopLanguage): SelectOption[] => [
  {
    value: 'updated-desc',
    label: language === 'en' ? 'Most recent' : 'Più recenti',
  },
  {
    value: 'name-asc',
    label: language === 'en' ? 'Name A–Z' : 'Nome A–Z',
  },
  {
    value: 'name-desc',
    label: language === 'en' ? 'Name Z–A' : 'Nome Z–A',
  },
  {
    value: 'price-asc',
    label: language === 'en' ? 'Price: low to high' : 'Prezzo crescente',
  },
  {
    value: 'price-desc',
    label: language === 'en' ? 'Price: high to low' : 'Prezzo decrescente',
  },
]

export const CATEGORY_SORT_SELECT_OPTIONS: SelectOption[] = getSortSelectOptions('it')
